export const dataKey: 'orders_by_classes' = 'orders_by_classes'
